// extracted by mini-css-extract-plugin
export default {"container":"b99ebf07d4b64e2a","row":"b8c94437006deab8"};